import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HomeInterestedFormComponent } from './home-interested-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { InputErrorModule } from 'src/app/core/components/input-error/input-error.module';
import { HeaderMenuModule } from 'src/app/shared/components/header-menu/header-menu.module';
import { PhoneMaskModule } from 'src/app/core/directives/phone-mask/phone-mask.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgbAccordionModule,
        InputErrorModule,
        HeaderMenuModule,
        PhoneMaskModule
    ],
    declarations: [
        HomeInterestedFormComponent
    ],
    exports: [
        HomeInterestedFormComponent
    ]
})
export class HomeContactFormModule {
}
